import { apiClient } from '../../../../lib/api-client';
import { CreditMemoProductSearchResult } from "../types/CreditMemoProductSearchResult"

export async function apiSearchCreditMemoProducts(productLineID: number, productTypeID?: number, sku?: string, description?: string):
    Promise<CreditMemoProductSearchResult> {
    try {
        return await apiClient.get("product/credit-memo-search",
            {
                params: {
                    productLineID: productLineID,
                    productTypeID: productTypeID,
                    sku: sku,
                    description: description
                }
            }) as CreditMemoProductSearchResult;
    }
    catch (error: any) {
        return {
            isSuccess: false,
            errorMessage: error,
            products: []
        };
    }
};
